import React from 'react';
import { StyledBurger } from './Burger.styled';

export const Burger = ({ isOpen, onClick, ...styledProps }) => {
  return (
    <StyledBurger isOpen={isOpen} onClick={onClick} {...styledProps}>
      <div />
      <div />
      <div />
    </StyledBurger>
  );
};
